import { customElement } from 'lit/decorators.js';
import { defaultStagedThreshold, EventCancellation } from '../../../../webmodule-common/other/general/staged-event';
import { FabricationJobListView } from '../../../fabrication-jobs/views/fabrication-job-list-view';
import { FabricationJobSummaryTable } from '../../../fabrication-jobs/views/fabrication-job-summary-table';
import { notificationSignal } from '../../../../webmodule-common/other/ui/icons/icon-notification-signal';
import { SSEFabricationJob } from '../../../api/fabrication-job-api';
import { stagedExecution } from '../../../../webmodule-common/other/general/event-source-client';
import { WMEventSource } from '../../../api/event-source';

@customElement('wm-franchiseefabricationjoblistview')
export class FranchiseeFabricationJobListView extends FabricationJobListView {
  private _eventCancel: EventCancellation = new EventCancellation();

  private _eventJobUpdated = stagedExecution({
    threshold: defaultStagedThreshold,
    cancelToken: this._eventCancel,
    eventFinally: () => notificationSignal(false),
    event: async () => {
      this.staleJobs = [];
      this.updatePageTotals();
      this.tables.forEach(t => (t.dataIsStale = true));
      const table = this.tabManager.activePage?.data as FabricationJobSummaryTable;
      if (table) {
        await table.refreshData();
        table.dataIsStale = false;
      }
    },
    eventTriggered: (_data: SSEFabricationJob) => {
      notificationSignal(true);
    },
    eventActioned: (_data: SSEFabricationJob) => {
      if (_data?.id && !this.staleJobs.includes(_data.id)) this.staleJobs.push(_data.id);
      const table = this.tabManager.activePage?.data as FabricationJobSummaryTable;
      table?.refreshData();
    }
  });

  afterRefresh() {
    this.staleJobs = [];
    this._eventCancel.cancel();
  }

  async dispose(): Promise<void> {
    await super.dispose();
    this._eventCancel.cancel();
  }

  connectedCallback(): void {
    super.connectedCallback();
    WMEventSource.getInstance().addEventListener(WMEventSource.fabricationJob, this._eventJobUpdated);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    WMEventSource.getInstance().removeEventListener(WMEventSource.fabricationJob, this._eventJobUpdated);
  }
}
